(function(){

	$('.input-file-custom input[type="file"]').on('change', function(){
		var value = $(this).val();
		var parent = $(this).parent('.input-file-custom');
		var output = parent.find('.output');
		output.text(value);
		$(this).blur()
	});
})();